(() => {
  const EXPERIMENT_ID = 'home_hero_bridge_v1';
  const EXPERIMENT_PARAM = 'exp_home_hero_bridge_v1';
  const EXPERIMENT_STORAGE_KEY = '__x4_exp_home_hero_bridge_v1';
  const VISITOR_STORAGE_KEY = '__x4_vid';
  const TTL_DAYS = 30;
  const VARIANTS = ['control', 'variant'];

  if (window.location.pathname !== '/') return;

  function parseJson(raw) {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  }

  function getCookie(name) {
    const pattern = new RegExp(`(?:^|; )${name}=([^;]*)`);
    const match = document.cookie.match(pattern);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function readStoredVariant() {
    let stored = null;

    try {
      stored = parseJson(localStorage.getItem(EXPERIMENT_STORAGE_KEY));
    } catch (error) {
      stored = null;
    }

    if (!stored || !stored.variant) {
      try {
        stored = parseJson(getCookie(EXPERIMENT_STORAGE_KEY));
      } catch (error) {
        stored = null;
      }
    }

    if (!stored || !stored.variant || !stored.expires_at) return null;
    if (Date.now() > stored.expires_at) return null;
    return stored.variant;
  }

  function writeStoredVariant(variant) {
    const payload = {
      variant: variant,
      assigned_at: Date.now(),
      expires_at: Date.now() + TTL_DAYS * 24 * 60 * 60 * 1000
    };

    try {
      localStorage.setItem(EXPERIMENT_STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
      /* no-op */
    }

    setCookie(EXPERIMENT_STORAGE_KEY, JSON.stringify(payload), TTL_DAYS);
  }

  function getOverrideVariant() {
    const params = new URLSearchParams(window.location.search);
    const forcedVariant = (params.get(EXPERIMENT_PARAM) || '').toLowerCase();
    return VARIANTS.includes(forcedVariant) ? forcedVariant : null;
  }

  function generateVisitorId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return `x4-${Date.now()}-${Math.floor(Math.random() * 1e8)}`;
  }

  function getVisitorId() {
    try {
      const localId = localStorage.getItem(VISITOR_STORAGE_KEY);
      if (localId) return localId;
    } catch (error) {
      /* no-op */
    }

    const cookieId = getCookie(VISITOR_STORAGE_KEY);
    if (cookieId) return cookieId;

    const newId = generateVisitorId();

    try {
      localStorage.setItem(VISITOR_STORAGE_KEY, newId);
    } catch (error) {
      /* no-op */
    }

    setCookie(VISITOR_STORAGE_KEY, newId, 365);
    return newId;
  }

  function hashString(input) {
    let hash = 0;
    for (let index = 0; index < input.length; index += 1) {
      hash = (hash << 5) - hash + input.charCodeAt(index);
      hash |= 0;
    }
    return Math.abs(hash);
  }

  function chooseVariant() {
    const visitorId = getVisitorId();
    const bucket = hashString(`${EXPERIMENT_ID}:${visitorId}`) % 2;
    return bucket === 0 ? 'control' : 'variant';
  }

  function applyVariantToDom(variant) {
    document.documentElement.dataset.expHomeHeroBridgeV1 = variant;
    if (document.body) {
      document.body.classList.add(`exp-home-hero-bridge-v1-${variant}`);
    }
  }

  function publishEvent(eventName, payload) {
    const eventPayload = Object.assign(
      {
        experiment_id: EXPERIMENT_ID,
        variant_id: resolvedVariant,
        page_type: 'home',
        page_path: window.location.pathname,
        timestamp: new Date().toISOString()
      },
      payload || {}
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      Object.assign(
        {
          event: eventName
        },
        eventPayload
      )
    );

    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      try {
        window.Shopify.analytics.publish(eventName, eventPayload);
      } catch (error) {
        /* no-op */
      }
    }
  }

  function publishAssignmentOnce(source) {
    const sessionKey = '__x4_exp_home_hero_bridge_v1_assigned';
    let alreadyPublished = null;

    try {
      alreadyPublished = sessionStorage.getItem(sessionKey);
    } catch (error) {
      alreadyPublished = null;
    }

    if (alreadyPublished === resolvedVariant) return;

    try {
      sessionStorage.setItem(sessionKey, resolvedVariant);
    } catch (error) {
      /* no-op */
    }

    publishEvent('exp_variant_assigned', {
      assignment_source: source
    });
  }

  function injectStyles() {
    if (document.getElementById('x4-exp-home-hero-bridge-style')) return;

    const style = document.createElement('style');
    style.id = 'x4-exp-home-hero-bridge-style';
    style.textContent = `
      .hero-promo-conversion-bridge {
        margin-top: 14px;
        padding: 14px;
        border: 1px solid #d9cdea;
        border-radius: 12px;
        background: #faf7ff;
      }
      .hero-promo-conversion-bridge__title {
        margin: 0 0 8px;
        font-size: 14px;
        font-weight: 700;
        color: #2a2144;
      }
      .hero-promo-conversion-bridge__chips {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        margin: 0;
        padding: 0;
        list-style: none;
      }
      .hero-promo-conversion-bridge__chips li {
        font-size: 11px;
        font-weight: 700;
        color: #4b3f66;
        padding: 4px 8px;
        border-radius: 999px;
        background: #efe7fb;
      }
      .hero-promo-conversion-bridge__link {
        display: inline-block;
        margin-top: 10px;
        font-size: 13px;
        font-weight: 700;
        color: #2a2144;
        text-decoration: none;
        border-bottom: 1px solid #2a2144;
      }
    `;
    document.head.appendChild(style);
  }

  function wireTracking(mainCta, bridgeLink) {
    if (mainCta && !mainCta.dataset.expHomeTracked) {
      mainCta.dataset.expHomeTracked = 'true';
      mainCta.addEventListener('click', () => {
        publishEvent('clarity_hero_bridge_click', {
          cta_position: 'main'
        });
      });
    }

    if (bridgeLink && !bridgeLink.dataset.expHomeTracked) {
      bridgeLink.dataset.expHomeTracked = 'true';
      bridgeLink.addEventListener('click', () => {
        publishEvent('clarity_hero_bridge_click', {
          cta_position: 'bridge'
        });
      });
    }
  }

  function applyVariantContent() {
    const heroSection = document.querySelector('[data-home-hero-section]') || document.querySelector('.hero-promo-split-section');
    if (!heroSection) return;

    const ctaButtons = heroSection.querySelector('[data-home-hero-buttons]') || heroSection.querySelector('.hero-promo-buttons');
    const mainCta = heroSection.querySelector('[data-home-hero-main-cta]') || (ctaButtons ? ctaButtons.querySelector('a') : null);
    const existingBridge = heroSection.querySelector('[data-home-hero-bridge]');

    if (!mainCta) return;

    if (!mainCta.dataset.expOriginalText) {
      mainCta.dataset.expOriginalText = mainCta.textContent.trim();
    }

    if (resolvedVariant === 'variant') {
      injectStyles();
      mainCta.textContent = 'See What Your DNA Reveals';

      if (!existingBridge && ctaButtons) {
        const bridge = document.createElement('div');
        bridge.className = 'hero-promo-conversion-bridge';
        bridge.setAttribute('data-home-hero-bridge', '');
        bridge.innerHTML = `
          <p class="hero-promo-conversion-bridge__title">Start with a personalized plan built from your DNA.</p>
          <ul class="hero-promo-conversion-bridge__chips">
            <li>HSA/FSA Eligible</li>
            <li>Free Shipping</li>
            <li>Results in 3-4 weeks</li>
          </ul>
          <a class="hero-promo-conversion-bridge__link" href="/products/3x4-health">Review the test details</a>
        `;
        ctaButtons.insertAdjacentElement('afterend', bridge);
      }
    } else {
      mainCta.textContent = mainCta.dataset.expOriginalText;
      if (existingBridge) {
        existingBridge.remove();
      }
    }

    wireTracking(mainCta, heroSection.querySelector('.hero-promo-conversion-bridge__link'));
  }

  const forcedVariant = getOverrideVariant();
  let resolvedVariant = forcedVariant || readStoredVariant();
  let assignmentSource = 'persisted';

  if (!resolvedVariant) {
    resolvedVariant = chooseVariant();
    writeStoredVariant(resolvedVariant);
    assignmentSource = 'generated';
  } else if (forcedVariant) {
    assignmentSource = 'query_override';
  }

  if (!VARIANTS.includes(resolvedVariant)) {
    resolvedVariant = 'control';
  }

  applyVariantToDom(resolvedVariant);

  document.addEventListener('DOMContentLoaded', () => {
    applyVariantToDom(resolvedVariant);
    applyVariantContent();
    publishAssignmentOnce(assignmentSource);
  });
})();
